import { Component, OnInit, OnDestroy } from '@angular/core';
import { FieldType } from 'ng-formly';
import { DataelementApi } from '../../sdk/services/custom';
import { LoopBackFilter } from '../../sdk/models/';
import * as _ from "lodash";
import { LoopBackAuth } from '../../sdk/services/core/auth.service';
import { PlatformApp } from '../../services/app.service';
/*
This custom field is used to select global dataelements for an app.
*/

@Component({
  selector: 'formly-dataelement-selector',
  template: `
   <ng-select *ngIf="items.length > 0"   
              [active]="selectedvalues"
              (data)="refreshValue($event)"
              (selected)="selected($event)"
              (removed)="removed($event)"
              [items]="items"
              [multiple]="false"
               [disabled]="to.disabled"
              placeholder="",
              [allowClear]="!to.required" >
  </ng-select>
  `, styleUrls: ['./ng2select.scss'],
  providers: [DataelementApi]
})
export class DataElementSelect extends FieldType implements OnInit, OnDestroy {
  _loopbackfilter: LoopBackFilter = <LoopBackFilter>{};
  items: any = [];
  selectedvalues: any = [];
  currentuser;
  appId;
  constructor(private _DataelementApi: DataelementApi, private _LoopBackAuth: LoopBackAuth, private _PlatformApp: PlatformApp) {
    super();
  }

  ngOnInit() {
    this.currentuser = this._LoopBackAuth.getCurrentUserData();
    if (PlatformApp.getAppVariable("platformApp")) {
      this.appId = PlatformApp.getAppVariable("referenceAppId");

    } else {
      this.appId = this.currentuser.appId
    }
    //1) Load the drop down values    

    //1) Load the drop down values    
    this._loopbackfilter.where = { 'appId': this.appId };
    //Hack - Get the app id from the model itself.
    //Get the dataelements for the App
    this._DataelementApi.find(this._loopbackfilter).subscribe((dataelements) => {
      if (dataelements) {
        for (var i = 0; i < dataelements.length; i++) {
          if (this.model.id !== dataelements[i]["id"]) {
            this.items.push({ id: dataelements[i]["id"], text: dataelements[i]["name"] })
          }

          if (this.model[this.key] && this.model[this.key].indexOf(dataelements[i]["id"]) > -1) {
            this.selectedvalues = [{ id: dataelements[i]["id"], text: dataelements[i]["name"] }];
          }
        }
        //Sort the values
        this.items = _.sortBy(this.items, 'text');
      }
    });

  }

  ngOnDestroy() {
    this.selectedvalues = "";
  }

  private value: any = {};


  public selected(value: any): void {
    this.model[this.key] = value.id;
  }

  public removed(value: any): void {

    /*
   Remove the removed value to the model
   */
    if (this.model[this.key] && this.model[this.key].length) {
      this.model[this.key].splice(this.model[this.key].indexOf(value.id), 1);
    }
  }

  public typed(value: any): void {

  }

  public refreshValue(value: any): void {
    this.value = value;
  }

}





// WEBPACK FOOTER //
// ./src/app/shared/components/fields/selectdataelement.ts